import React from "react"

import LegalDisbursementsModal from "../../shared-components/legal-disbursements-modal"

type LegalDisbursementsContextType = {
  isLegalDisbursementsModalOpen: boolean
  setIsLegalDisbursementsModalOpen: (isOpen: boolean) => void
}

interface Props {
  children: React.ReactNode
}

export const LegalDisbursementsContext =
  React.createContext<LegalDisbursementsContextType>({
    isLegalDisbursementsModalOpen: false,
    setIsLegalDisbursementsModalOpen: () => undefined,
  })

export const LegalDisbursementsProvider = ({ children }: Props) => {
  const [isLegalDisbursementsModalOpen, setIsLegalDisbursementsModalOpen] =
    React.useState<boolean>(false)

  const value = React.useMemo(() => {
    return {
      isLegalDisbursementsModalOpen,
      setIsLegalDisbursementsModalOpen,
    }
  }, [isLegalDisbursementsModalOpen, setIsLegalDisbursementsModalOpen])
  return (
    <LegalDisbursementsContext.Provider value={value}>
      <LegalDisbursementsModal
        open={isLegalDisbursementsModalOpen}
        onClose={() => setIsLegalDisbursementsModalOpen(false)}
      />
      {children}
    </LegalDisbursementsContext.Provider>
  )
}

export const useLegalDisbursementsContext = () =>
  React.useContext(LegalDisbursementsContext)
